"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const firestore_1 = require("firebase/firestore");
const firestore_web_1 = require("comodel/firestore-web");
const react_hook_form_1 = require("react-hook-form");
const hooks_1 = require("common/hooks");
const firestore = (0, firestore_1.getFirestore)(firebase_app_1.default);
const UniqueIdSchemaComponent = (props) => {
    const { trigger } = (0, react_hook_form_1.useFormContext)();
    let originalValue = null;
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
        (value_1, _a) => __awaiter(void 0, [value_1, _a], void 0, function* (value, { schema, label }) {
            const { resourcePath, idKey } = schema;
            if (!value)
                return;
            if (props.schema.existent) {
                if (value === originalValue) {
                    return;
                }
            }
            if (idKey && idKey === props.fieldPath) {
                const docRef = (0, firestore_1.doc)(firestore, resourcePath, value);
                const docSnapshot = yield (0, firestore_1.getDoc)(docRef);
                if (docSnapshot.exists()) {
                    return `${value}はすでに存在します`;
                }
            }
            else {
                const collectionRef = (0, firestore_1.collection)(firestore, resourcePath);
                const queryRef = (0, firestore_1.query)(collectionRef, ...(0, firestore_web_1.getQueryConstraints)({
                    filter: { [props.fieldPath]: value },
                }));
                const snapshot = yield (0, firestore_1.getDocs)(queryRef);
                console.log(snapshot);
                if (snapshot.size) {
                    return `${value}はすでに存在します`;
                }
            }
        }),
    ]);
    originalValue = (0, hooks_1.useMemoWithPrev)((prev) => {
        if (prev)
            return prev;
        return value;
    }, [value]);
    (0, react_1.useEffect)(() => {
        trigger(props.fieldPath);
    }, [value]);
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(Form_1.default.Control, Object.assign({ type: "text", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), value: value || "" }, registerProps))));
};
UniqueIdSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("UniqueIdDisplayComponent");
exports.default = UniqueIdSchemaComponent;
